var envConfig = {
     //ContentAPI:'https://ceapp.powertochange.org.au',
    // ContentAPI:'https://ceapp',
    // ContentAPI: 'https://timetapz.ideahero.com',
    // APIx: 'http://tapz/v1/api.php',
    APIx: 'http://localhost/v1/api.php',
    API: 'https://api.timetapz.au/v1/api.php',
    _rt:null,
    redirect:function(url){
        this._rt.push(url);
    }

}


export default envConfig

